// 경량 진단 로거 — 데스크톱(Tauri)에서 콘솔이 안 보이므로, 메모리 + localStorage 에 로그를 쌓아
// 로그인 화면에서 "로그 복사" 로 사용자가 퍼갈 수 있게 한다. 웹에서도 무해하게 동작.
const KEY = 'tpt-diag-log';
const MAX = 300;
const buf: string[] = [];

function stamp(): string {
	try { return new Date().toISOString().slice(11, 23); } catch { return '??'; }
}

// Tauri 여부 — import 순환 피하려 inline 감지.
const IS_TAURI = typeof window !== 'undefined'
	&& (window.location.protocol === 'tauri:' || /tauri\.localhost/i.test(window.location.host || ''));

export function diagLog(...parts: unknown[]): void {
	const line = `[${stamp()}] ` + parts.map((p) => (typeof p === 'string' ? p : (() => { try { return JSON.stringify(p); } catch { return String(p); } })())).join(' ');
	buf.push(line);
	if (buf.length > MAX) buf.shift();
	try { localStorage.setItem(KEY, buf.join('\n')); } catch { /* private mode */ }
	try { console.log('[diag]', line); } catch { /* */ }
	// 데스크톱: 실행파일 옆 logs/tptalk.log 에 파일로도 누적 (Rust append_log 커맨드). fire-and-forget.
	if (IS_TAURI) {
		import('@tauri-apps/api/core').then(({ invoke }) => invoke('append_log', { line })).catch(() => { /* */ });
	}
}

export function getDiag(): string {
	try { return localStorage.getItem(KEY) || buf.join('\n'); } catch { return buf.join('\n'); }
}

// 전역 에러/거부 캡처 — 한 번만 설치.
let installed = false;
export function installDiag(): void {
	if (installed || typeof window === 'undefined') return;
	installed = true;
	window.addEventListener('error', (e) => diagLog('window.error', e.message, (e.error as Error)?.stack?.split('\n')[0] || ''));
	window.addEventListener('unhandledrejection', (e) => diagLog('unhandledrejection', String((e as PromiseRejectionEvent).reason)));
}
